
ko.bindingHandlers.modal = {
    init: function (element, valueAccessor, allBindings) {
        //const hasBackdrop = ko.unwrap(allBindings.get('hasBackdrop')) !== false;

        //$(element).modal({
        //    show: false,
        //    backdrop: hasBackdrop
        //});

        var value = valueAccessor();

        if (ko.isObservable(value)) {
            $(element).on('hidden.bs.modal', function () {
                value(false);
                $(".modal-backdrop").remove();
            });
        }

    },
    update: function (element, valueAccessor, allBindings) {
        const hasBackdrop = ko.unwrap(allBindings.get('hasBackdrop')) !== false;
        const bodyFaded = ko.unwrap(allBindings.get('bodyFaded')) === true;

        var value = valueAccessor();

        if (ko.utils.unwrapObservable(value)) {
            bodyFaded && setBackgroundOpacity('0.5');
            $(element).data('bs.modal')._config.backdrop = hasBackdrop;
            $(element).modal({
                show: true,
                backdrop: hasBackdrop
            });
        } else {
            setBackgroundOpacity('');
            $(element).modal('hide');
            $(".modal-backdrop").remove();
        }
    }
};

function setBackgroundOpacity(opacity) {
    $('.main-app-nav, .main-app-content').css('opacity', opacity);
}